import { Box, Chip, Divider, IconButton, Tooltip, Typography } from '@mui/material'
import { map } from 'lodash'
import { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Notistack } from '../../../../components/Notistack'
import { RightSidebarWrapper } from '../../../../components/Wrapper/RightSidebarWrapper'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import CloseCircleIcon from './../../../../assets/icons/CloseCircle.svg?react'
import CopyIcon from './../../../../assets/icons/Copy.svg?react'
import Citations from './Citations'

const CitationSideBar = () => {
    const { setOpenSidebarType } = useWrapperStore((state) => state)
    const { messageCitations, requestDetail } = useRequestsStore((state) => state)
    const [openSnackbar, setOpenSnackbar] = useState(false)

    const citationList = map(messageCitations, 'link').join(', ')

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    return (
        <RightSidebarWrapper>
            <Box sx={{ p: 2, alignItems: 'center', display: 'flex', gap: '8px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
                        <Typography color="text" variant="h5" sx={{ fontWeight: 500 }}>
                            Источники
                        </Typography>
                        <CopyToClipboard onCopy={() => setOpenSnackbar(true)} text={citationList}>
                            <Tooltip title="Скопировать ссылки на все источники">
                                <IconButton
                                    size="small"
                                    sx={{
                                        backgroundColor: (theme) => theme.palette.primary.main,
                                        padding: '4px',
                                    }}
                                    edge="end">
                                    <CopyIcon />
                                </IconButton>
                            </Tooltip>
                        </CopyToClipboard>
                        <Chip
                            size="medium"
                            sx={{
                                '& .MuiChip-label': {
                                    marginRight: '0',
                                },
                            }}
                            label={messageCitations?.length}
                        />
                    </Box>
                    <Typography
                        variant="caption2"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            color: '#9195A1',
                        }}>
                        {requestDetail?.name}
                    </Typography>
                </Box>
                <IconButton
                    sx={{ height: '40px', padding: 0, marginLeft: 'auto' }}
                    onClick={() => setOpenSidebarType(null)}>
                    <CloseCircleIcon />
                </IconButton>
            </Box>
            <Divider />
            <Citations />
            <Notistack
                open={openSnackbar}
                isError={false}
                message="Источники скопированы"
                onClose={handleCloseSnackbar}
            />
        </RightSidebarWrapper>
    )
}

export default CitationSideBar
